import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import ChecklistElement from './ChecklistElementModel';
import Checkbox from '@mui/material/Checkbox';
import EditorType from '../../../Enums/EditorType';
import type { JSX } from 'react';

class CheckboxChecklistElement extends ChecklistElement {

    public constructor(elementId: string, name: string, itemNumber: string | null, sortNumber: number) {

        super(elementId, name, itemNumber, sortNumber, EditorType.CHECKBOX);
    }

    public buildFormElement(value: boolean, onChange: (value: boolean) => Promise<void>, primaryTextColor: string): JSX.Element {

        return (
            <React.Fragment key={this.elementId}>
                <FormControlLabel
                    control={
                        <Checkbox
                            color='primary'
                            checked={value}
                            onChange={async (e: React.ChangeEvent<HTMLInputElement>): Promise<void> => onChange(e.target.checked)}
                        />
                    }
                    label={
                        <span style={{
                            color: primaryTextColor,
                        }}>
                            {this.name}
                        </span>
                    }
                />
                <br />
                <br />
            </React.Fragment>
        );
    }
}

export default CheckboxChecklistElement;